var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.6257V12.2621L15.75 10.0803L13.5 7.89844V9.5348C11.0137 9.5348 9 11.4875 9 13.8984C9 14.7548 9.25875 15.5512 9.6975 16.2221L10.5187 15.4257C10.2656 14.973 10.125 14.4493 10.125 13.8984C10.125 12.093 11.6381 10.6257 13.5 10.6257ZM17.3025 11.5748L16.4812 12.3712C16.7287 12.8293 16.875 13.3475 16.875 13.8984C16.875 15.7039 15.3619 17.1712 13.5 17.1712V15.5348L11.25 17.7166L13.5 19.8984V18.2621C15.9863 18.2621 18 16.3093 18 13.8984C18 13.0421 17.7413 12.2457 17.3025 11.5748V11.5748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4873 1C12.7898 1 13.0018 1.12908 13.124 1.38574C13.2461 1.64231 13.2203 1.88687 13.0459 2.12012L8.99605 7.30078V9.07324C8.13906 9.84214 7.59962 10.9582 7.59956 12.2002H6.90132C6.70366 12.2001 6.53799 12.1331 6.40425 11.999C6.27046 11.8649 6.20308 11.6983 6.20308 11.5V7.30078L2.15425 2.12012C1.97979 1.8869 1.95317 1.64227 2.07515 1.38574C2.19734 1.12908 2.41029 1 2.71285 1H12.4873ZM7.59956 6.81055L11.0556 2.40039H4.14351L7.59956 6.81055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.3f4bb8990cb3e449c3b348626e31d091.svg";
export { ForwardRef as ReactComponent };